type PermittedUsersProduct = 'jira' | 'confluence' | 'loom';
export type PermittedUsersWithProduct<Product extends PermittedUsersProduct> = {
	[userId: string]: Product[] | undefined;
};

export const getPermittedUsersWithProducts = async <Product extends PermittedUsersProduct>(
	products: ReadonlyArray<Product>,
	cloudId: string,
	accountIds: ReadonlyArray<string>,
): Promise<PermittedUsersWithProduct<Product>> => {
	const response = await fetch(
		'/gateway/api/growth/invite-notify-1p/get-permitted-users-with-products',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				cloudId,
				products,
				accountIds,
			}),
		},
	);

	return (await response.json()) as PermittedUsersWithProduct<Product>;
};
